import {getURISegment} from '@Utils/url.util';
import {getSupportedVisibilityChangeEvent} from '@Utils/browser.util';
import type {Editor} from 'grapesjs';
import type {PrimaryConfigOptions} from '@/email-maker/grapesjs-email-editor-plugin/src';

interface FileUploadEvent {
  dataTransfer?: DataTransfer | null;
  target: HTMLInputElement;
}

interface UploadFile extends File {
  [key: string]: any;
}

interface AssetUploadResponse {
  data: any;
}

/**
 * Listeners related to the Storage
 * @param opt The grapesjs config object
 */
export default (opt: PrimaryConfigOptions): void => {
  const editor = opt.editor;
  const assets = editor.AssetManager;
  const assetsConfig = assets.getConfig();

  assetsConfig.uploadFile = function (e: any): void {
    const files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
    let formData: FormData;

    if (files && files.length > 0) {
      for (const file of files) {
        formData = new FormData();
        formData.append('Filedata', file as File);

        window.PMW.write(window.PMW.util.site_url('posterimage/emailUpload'), formData)
          .then(function (result: AssetUploadResponse): void {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const image = result.data; // <- should be an array of uploaded images
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            editor.AssetManager.add(image);

            editor.runCommand(window.PMW.emails.commands.UPDATE_LOADING_IMG_WITH_RESPONSE, {
              // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
              identifier: (file as any)[window.PMW.emails.props.DROP_IDENTIFIER],
              imgResponse: image
            });
          })
          .catch((error: unknown) => {
            console.error('Upload failed:', error);
          });
      }
    }
  };

  editor.on('asset:upload:response', (response: string) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const result: AssetUploadResponse = JSON.parse(response);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    editor.AssetManager.add(result.data);
  });

  document.addEventListener(window.PMW.emails.CUSTOM_EVENT_STORAGE_END, async (_data: Event) => {
    if (window.PMW.emails.SAVE_QUEUED) {
      window.PMW.emails.SAVE_QUEUED = false;
      await editor.store({});
    }
  });

  attachListenersToSaveToDB(editor, window.PMW.emails.commands.SAVE_TO_DB);
  // eslint-disable-next-line no-restricted-globals
  $(document).ready(appendInhouseDesignerURI);

  function appendInhouseDesignerURI(): void {
    if (getURISegment(3)) {
      // eslint-disable-next-line no-restricted-globals
      const newEmailCta = $('.js-new-email-cta');
      newEmailCta.attr('href', (newEmailCta.attr('href') ?? '') + '//1');
    }
  }
};

/**
 * Attach listeners to save to database
 * @param editor The grapesjs editor instance
 * @param saveToDbCommand The command to save to database
 */
export function attachListenersToSaveToDB(editor: Editor, saveToDbCommand: string): void {
  const [visibilityChange, visibilityHidden] = getSupportedVisibilityChangeEvent();
  document.addEventListener(visibilityChange, function (): void {
    if (!document[visibilityHidden as keyof Document]) {
      return;
    }
    onNavigateAway(editor, saveToDbCommand);
  });
  // running on beforeUnload as a backup for browsers that don't trigger visibilityChange on refresh/window-close
  window.addEventListener('beforeunload', () => {
    onNavigateAway(editor, saveToDbCommand);
  });
}

/**
 * trigger endpoint to save cached payload to DB
 * @param editor The grapesjs editor instance
 * @param saveToDbCommand The command to save to database
 */
function onNavigateAway(editor: Editor, saveToDbCommand: string): void {
  editor.runCommand(saveToDbCommand, {});
}